module.exports = __webpack_public_path__ + "img/parliament.6d6c2bb4.png";